import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ModalPermissionBrowser = _resolveComponent("ModalPermissionBrowser")!
  const _component_SpeechRecognition = _resolveComponent("SpeechRecognition")!
  const _component_FeedbackObjective = _resolveComponent("FeedbackObjective")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_QuizStudent = _resolveComponent("QuizStudent")!
  const _component_Material = _resolveComponent("Material")!
  const _component_Chat = _resolveComponent("Chat")!
  const _component_CourseCertificate = _resolveComponent("CourseCertificate")!
  const _component_CourseLearningMapStudent = _resolveComponent("CourseLearningMapStudent")!

  return (_ctx.loaderChapters)
    ? (_openBlock(), _createBlock(_component_Loader, {
        key: 0,
        loader: _ctx.loaderChapters
      }, null, 8, ["loader"]))
    : (_openBlock(), _createElementBlock("main", {
        key: 1,
        class: _normalizeClass(["flex flex-col", [
      {
        'bg-h-primary-100 min-h-screen': _ctx.alertStore?.show,
        'mx-auto': !_ctx.alertStore?.show,
        container: _ctx.progressStore.status === _ctx.StatusProgress.INIT_OBJECTIVE,
      },
    ]])
      }, [
        _createElementVNode("div", null, [
          _createVNode(_component_ModalPermissionBrowser),
          (_ctx.courseStore?.hasSpeechRecognition)
            ? (_openBlock(), _createBlock(_component_SpeechRecognition, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        (_ctx.feedbackStore?.feedback)
          ? (_openBlock(), _createBlock(_component_FeedbackObjective, {
              key: 0,
              itemId: _ctx.learningObjectiveStore?.learningObjective.id,
              idCourse: _ctx.courseId,
              idUser: _ctx.userId,
              onOnSendFeedback: _ctx.feedbackStore?.sendFeedback
            }, null, 8, ["itemId", "idCourse", "idUser", "onOnSendFeedback"]))
          : _createCommentVNode("", true),
        (_ctx.alertStore?.showAlert && !_ctx.feedbackStore?.feedback)
          ? (_openBlock(), _createBlock(_component_Alert, {
              type: _ctx.alertStore?.type,
              data: _ctx.alertStore?.getCurrentData,
              key: _ctx.alertStore?.type
            }, null, 8, ["type", "data"]))
          : _createCommentVNode("", true),
        (_ctx.progressStore?.status === _ctx.StatusProgress.INIT_QUIZ)
          ? (_openBlock(), _createBlock(_component_QuizStudent, {
              key: 2,
              onOnProceed: _ctx.quizStore?.proceedQuiz,
              onOnEnded: _ctx.quizStore?.quizEnded,
              onOnClose: _ctx.quizStore?.closeQuiz,
              quiz: _ctx.quizStore?.quizData,
              quizIntro: _ctx.quizStore?.quizIntro,
              quizEnded: _ctx.quizStore?.quizHasEnded,
              learningName: _ctx.chapterStore?.getCurrentChapter?.name,
              isAdaptative: true
            }, null, 8, ["onOnProceed", "onOnEnded", "onOnClose", "quiz", "quizIntro", "quizEnded", "learningName"]))
          : _createCommentVNode("", true),
        (_ctx.progressStore?.status === _ctx.StatusProgress.INIT_OBJECTIVE)
          ? (_openBlock(), _createBlock(_component_Material, { key: 3 }))
          : _createCommentVNode("", true),
        (_ctx.chatStore?.show)
          ? (_openBlock(), _createBlock(_component_Chat, {
              key: 4,
              onOnBackMaterial: _ctx.materialStore?.goBack,
              onOnCheckVideoEnded: _ctx.materialStore?.goNext,
              indexMaterial: _ctx.materialStore?.indexMaterial,
              user: _ctx.user,
              msgType: 'default',
              currentMaterial: _ctx.materialStore?.getCurrentMaterial,
              hSize: `!h-[90vh]`,
              class: "custom-adapt-chat",
              ref: "chat"
            }, null, 8, ["onOnBackMaterial", "onOnCheckVideoEnded", "indexMaterial", "user", "currentMaterial"]))
          : _createCommentVNode("", true),
        (_ctx.progressStore?.status === _ctx.StatusProgress.CERTIFICATE)
          ? (_openBlock(), _createBlock(_component_CourseCertificate, {
              key: 5,
              courseId: _ctx.courseId,
              userId: _ctx.user.id
            }, null, 8, ["courseId", "userId"]))
          : _createCommentVNode("", true),
        (_ctx.materialStore?.showMap)
          ? (_openBlock(), _createBlock(_component_CourseLearningMapStudent, {
              key: 6,
              onOnCloseMap: _ctx.materialStore?.setShowMap
            }, null, 8, ["onOnCloseMap"]))
          : _createCommentVNode("", true)
      ], 2))
}